import { render, staticRenderFns } from "./closeNode.vue?vue&type=template&id=c190b40a&"
import script from "./closeNode.vue?vue&type=script&lang=js&"
export * from "./closeNode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports